module.exports = __webpack_public_path__ + "img/mqttx-dark.0a8db21e.png";